module.exports = __webpack_public_path__ + "media/app/images/sponsorship_cta-25da8b96d4edb9e8ce98170b5ba513da.png";